import React from 'react';
import './StepsIndicator.scss';

interface Props {
  count: number;
  step: number;
}

const StepsIndicator = ({ count, step }) => {
  return (
    <>
      <div className="steps-indicator">
        <ol>
          {count !== 0
            ? [...Array(count)].map((c, index) => {
                return (
                  <li className={step >= index + 1 ? 'active' : ''} key={index}>
                    <span className="index">{index + 1}</span>
                    <span className="line"></span>
                  </li>
                );
              })
            : ''}
        </ol>
      </div>
    </>
  );
};

export default StepsIndicator;
